module.exports = __webpack_public_path__ + "static/media/history1.2c1a806f.jpg";